import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";

import { ProgramAutomationTaskStatus } from "@fitness-app/data-models/entities/ProgramAutomation";

import { supabase } from "~/store/initializeStore";

export const useDeleteScheduledMessagesSequence = () => {
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: async (sequenceId: string) => {
      message.loading({ content: "Usuwanie zaplanowanych wiadomości...", key: "deleteSequence" });

      // First, delete all tasks associated with this sequence
      const { error: tasksError } = await supabase
        .from("program_automation_task")
        .delete()
        .eq("sequenceGroupId", sequenceId)
        .not("status", "eq", ProgramAutomationTaskStatus.Done);

      if (tasksError) {
        throw new Error(tasksError.message);
      }

      // Then, delete the sequence aggregate
      const { error: sequenceError } = await supabase.from("planned_tasks_sequence").delete().eq("id", sequenceId);

      if (sequenceError) {
        throw new Error(sequenceError.message);
      }

      return sequenceId;
    },
    onSuccess: () => {
      message.destroy("deleteSequence");
      message.success("Zaplanowane wiadomości zostały usunięte");
      void queryClient.invalidateQueries({ queryKey: ["scheduled_messages_sequence"] });
      void queryClient.invalidateQueries({ queryKey: ["scheduled_messages_sequence_count"] });
    },
    onError: (error: Error) => {
      message.destroy("deleteSequence");
      message.error(`Błąd podczas usuwania: ${error.message}`);
    },
  });

  return {
    deleteMutation,
  };
};
